import { BreadCrumbItemType } from "../../common/types";
import { COMMON_ACTIONS } from "../thunks/common.thunk";

interface CommonSliceProps {
  breadCrumb: BreadCrumbItemType[];
  history: string[];
}

const initialState: CommonSliceProps = {
  breadCrumb: [],
  history: [],
};

export default function commonReducer(state = initialState, action: any) {
  switch (action.type) {
    case COMMON_ACTIONS.ADD_BREADCRUMB:
      var breadCrumbCopy = state.breadCrumb.slice();
      if (Array.isArray(action.payload)) {
        action.payload.forEach((item: BreadCrumbItemType) => {
          breadCrumbCopy.push(item);
        });
      }
      state = {
        ...state,
        breadCrumb: breadCrumbCopy,
      };
      return state;

    case COMMON_ACTIONS.REMOVE_BREADCRUMB:
      breadCrumbCopy = state.breadCrumb.slice();

      if (Array.isArray(action.payload)) {
        action.payload.forEach((item: BreadCrumbItemType) => {
          var index = breadCrumbCopy.findIndex(
            (breadCrumb: BreadCrumbItemType) => breadCrumb.text === item.text
          );

          if (index > -1) {
            breadCrumbCopy.splice(index, 1);
          }
        });
      }
      state = {
        ...state,
        breadCrumb: breadCrumbCopy,
      };
      return state;

    case COMMON_ACTIONS.SET_HISTORY:
      let temp: any = state.history;
      const index = temp.indexOf(action.payload);
      if (index === -1) {
        temp.push(action.payload);
      } else {
        temp.splice(index + 1);
      }

      state = {
        ...state,
        history: temp,
      };

      return state;

    case COMMON_ACTIONS.RESET_HISTORY:
      state = {
        ...state,
        history: [],
      };

      return state;

    default:
      return state;
  }
}
